import { useState } from 'react'
import { Props_SnippetVideo } from './Video.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const processUrl = (url: string): string => {
    let newUrl = url

    // Handle YouTube URLs
    if (url.includes('watch?v=')) {
        newUrl = url.replace('watch?v=', 'embed/')
    } else if (url.includes('youtu.be')) {
        newUrl = url.replace('youtu.be/', 'youtube.com/embed/')
    }

    // Handle Vimeo URLs
    if (url.includes('vimeo.com')) {
        const match = url.match(/vimeo\.com\/(\d+)/)
        if (match) {
            newUrl = `https://player.vimeo.com/video/${match[1]}`
        }
    }

    // Add autoplay for all URLs if not already present
    if (!newUrl.includes('autoplay=1')) {
        newUrl = `${newUrl}${newUrl.includes('?') ? '&' : '?'}autoplay=1`
    }
    
    return newUrl
}

const SnippetVideo = (props: Props_SnippetVideo) => {
    const { heading, content, video } = props

    const convertedUrl = processUrl(video?.url?.value ?? '')
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-video__heading--${heading.visibility.value}` : ''
    const [playing, setPlaying] = useState(false)

    return (
        <section className={`snippet-video snippet-video--${content.position?.value} ${playing ? 'snippet-video--playing' : ''}`}>
            <div className="snippet-video__container">
                <div className="snippet-video__container-content">
                    <h2 className={`snippet-video__heading ${classHeadingVisibility}`}>{heading.heading?.value}</h2>
                    <div className="snippet-video__content">
                        { content.content?.value && Legacy_CompileMarkdown(content.content.value) }
                        { content.linkContent?.value && content.linkUrl?.value && content.linkTarget?.value && (
                            <a
                                href={content.linkUrl?.value} 
                                className="snippet-video__link"
                                target={content.linkTarget?.value === 'true' ? '_blank' : '_self'}
                                rel={content.linkTarget?.value === 'true' ? 'noopener noreferrer' : undefined}
                            >
                                {content.linkContent?.value}
                            </a>
                        )}
                    </div>
                </div>
                <div className={`snippet-video__container-video`}>
                    <button
                        className="snippet-video__play-button play-button"
                        aria-label="{{js.snippet.video.button.play.aria-label}}"
                        onClick={() => setPlaying(true)}
                    ></button>
                    { video.thumbnail?.value && (
                        <figure className="snippet-video__container-thumbnail">
                            <img
                                src={video.thumbnail?.value}
                                alt=""
                                className="snippet-video__thumbnail"
                                loading="lazy"
                                width="1920"
                                height="1080"
                            />
                        </figure>
                    )}
                    <iframe
                        width="560"
                        height="315"
                        src={convertedUrl}
                        title="YouTube video player"
                        loading="lazy"
                        allow="accelerometer autoplay clipboard-write encrypted-media gyroscope picture-in-picture web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        className="snippet-video__video"
                        allowFullScreen={true}
                    ></iframe>
                </div>
            </div>
        </section>
    )
}

export default SnippetVideo
